import React from "react";
import { Button, Result } from "antd";
const Index = () => (
  <div
    style={{
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Result status="500" title="500" subTitle="Sorry, something went wrong." />
  </div>
);
export default Index;
